module.exports = __webpack_public_path__ + "static/media/icon-print.73221955.svg";